export default "__VITE_ASSET__Bza6SRbW__"